import React from "react";
import { Link } from "react-router-dom";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Drawing() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 0 40px 0",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 12,
            }}
          >
            Drawing
          </h1>
          <p
            style={{
              fontSize: "1.3rem",
              color: "#333",
              marginBottom: 32,
              maxWidth: 600,
              textAlign: "center",
            }}
          >
            Discover creative coding art and turtle graphics projects. These
            Python-based drawing programs are perfect for learning programming
            and making beautiful designs.
          </p>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 40,
              marginBottom: 40,
            }}
          >
            {/* Rainbow Turtle */}
            <Link to="/rainbow_turtle" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/rainbow_turtle.gif"
                  alt="Rainbow Turtle"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                  }}
                />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Rainbow Turtle
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                A colorful spiral drawn using Python's turtle graphics.
              </p>
              <a
                href="/rainbow_turtle.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download rainbow_turtle.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to watch the turtle draw a rainbow spiral!
              </div>
            </div>
            </Link>
            {/* Robot */}
            <Link to="/robot" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/robot.gif"
                  alt="Robot"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                  }}
                />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Robot Drawing
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                A fun robot drawn with turtle graphics and simple shapes.
              </p>
              <a
                href="/robot.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download robot.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to see a robot come to life on your screen!
              </div>
            </div>
            </Link>
            {/* India Flag */}
            <Link to="/india_flag" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/india_flag.gif"
                  alt="India Flag"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                  }}
                />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                India Flag
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                The Indian flag drawn with Python turtle graphics.
              </p>
              <a
                href="/india_flag.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download india_flag.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to see the Indian flag being drawn!
              </div>
            </div>
            </Link>
            {/* Man */}
            <Link to="/man" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/man.gif"
                  alt="Man"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                  }}
                />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Man Drawing
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                A simple stick figure man using turtle graphics.
              </p>
              <a
                href="/man.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download man.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to draw a simple stick figure man!
              </div>
            </div>
            </Link>
            {/* Happy Diwali */}
            <Link to="/happy_diwali" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/happy_diwali.gif"
                  alt="Happy Diwali"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                  }}
                />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Happy Diwali
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                A festive Diwali celebration drawing.
              </p>
              <a
                href="/happy_dipawali_diwali.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download happy_dipawali_diwali.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to celebrate Diwali with code!
              </div>
            </div>
            </Link>
            {/* New Year */}
            <Link to="/new_year" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <ImageWithFallback
                src="/new_year_2023.png"
                alt="New Year"
                style={{
                  width: 220,
                  borderRadius: 18,
                  marginBottom: 18,
                }}
              />
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                New Year Drawing
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Celebrate the new year with a festive turtle drawing.
              </p>
              <a
                href="/new_year_2023.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download new_year_2023.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to see a New Year greeting drawn live!
              </div>
            </div>
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}

export default Drawing;
